export const VALIGN_MAP = {
  start: "top",
  end: "bottom",
  center: "middle",
  baseline: "baseline",
}
